export const generateRandomId = (limit = 16) => {
  return (Math.random() * Date.now()).toString().replace('.', '').substring(0, limit);
};
